/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Flex_Title_SomeInputs */

const en_us2_profile_editors_flex_title_some = /** @type {(inputs: Profile_Editors_Flex_Title_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fixed day`)
};

const pt_br2_profile_editors_flex_title_some = /** @type {(inputs: Profile_Editors_Flex_Title_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dia fixo`)
};

const es_419_profile_editors_flex_title_some = /** @type {(inputs: Profile_Editors_Flex_Title_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin día fijo`)
};

const pt_pt2_profile_editors_flex_title_some = /** @type {(inputs: Profile_Editors_Flex_Title_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dia fixo`)
};

const fr_fr2_profile_editors_flex_title_some = /** @type {(inputs: Profile_Editors_Flex_Title_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans jour fixe`)
};

const de_de2_profile_editors_flex_title_some = /** @type {(inputs: Profile_Editors_Flex_Title_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein fester Tag`)
};

const it_it2_profile_editors_flex_title_some = /** @type {(inputs: Profile_Editors_Flex_Title_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza giorno fisso`)
};

/**
* | output |
* | --- |
* | "No fixed day" |
*
* @param {Profile_Editors_Flex_Title_SomeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_flex_title_some = /** @type {((inputs?: Profile_Editors_Flex_Title_SomeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Flex_Title_SomeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_flex_title_some(inputs)
	if (locale === "es-419") return es_419_profile_editors_flex_title_some(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_flex_title_some(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_flex_title_some(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_flex_title_some(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_flex_title_some(inputs)
	return en_us2_profile_editors_flex_title_some(inputs)
});
export { profile_editors_flex_title_some as "profile-editors.flex_title_some" }